import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SearchModel, SearchResultModel } from 'src/common/components';
import { DocumentComponentName } from 'src/common/enums/documentComponentName';
import { environment } from 'src/environments/environment';
import {  DocumentFileDownloadModel, DocumentFileSaveModel, DocumentFileSearchModel, DocumentPagesModel, DocumentPagesRequestModel } from './documents.model';

@Injectable()
export class DocumentsService {
  httpParams:HttpParams;
  constructor(private http: HttpClient) {}

  getDocumentPages(model: DocumentPagesRequestModel): Promise<DocumentPagesModel> {
    return this.http.post<DocumentPagesModel>(`${environment.apiUrl}/Documents/DocumentPages`, model).toPromise();
  }

  getDocumentPagesCount(id: number): Promise<number> {
    return this.http.get<number>(`${environment.apiUrl}/Documents/DocumentPagesCount/${id}`).toPromise();
  }

  // File
  searchDocument(search: SearchModel, id: number,documentComponentName:DocumentComponentName): Promise<SearchResultModel<any>> {
    let documentFileSearchModel = new DocumentFileSearchModel();
    documentFileSearchModel.search=search;
    documentFileSearchModel.documentComponentName=documentComponentName;

    return this.http.post<SearchResultModel<any>>(`${environment.apiUrl}/Documents/SearchDocument/${id}`, documentFileSearchModel,).toPromise();
  }

  getAllDocument(id: number,documentComponentName:DocumentComponentName): Promise<any[]> {
    this.httpParams = new HttpParams();
    this.httpParams =   this.httpParams.append('documentComponentName', documentComponentName);
    return this.http.get<any[]>(`${environment.apiUrl}/Documents/AllDocument/${id}`,{params:this.httpParams}).toPromise();
  }

  deleteDocument(id: number,documentComponentName:DocumentComponentName): Promise<void> {
    this.httpParams = new HttpParams();
    this.httpParams =   this.httpParams.append('documentComponentName', documentComponentName);
    return this.http.delete<void>(`${environment.apiUrl}/Documents/DeleteDocument/${id}`,{params:this.httpParams}).toPromise();
  }

  saveDocument(model: DocumentFileSaveModel): Promise<void> {
    return this.http.post<void>(`${environment.apiUrl}/Documents/SaveDocument`, model).toPromise();
  }

  downloadDocument(id: number,documentComponentName:DocumentComponentName): Promise<DocumentFileDownloadModel> {
    this.httpParams = new HttpParams();
    this.httpParams =   this.httpParams.append('documentComponentName', documentComponentName);
    return this.http.get<DocumentFileDownloadModel>(`${environment.apiUrl}/Documents/DownloadDocument/${id}`,{params:this.httpParams}).toPromise();
  }

  supplierUserConditionsDocumentId(): Promise<number> {
    return this.http.get<number>(`${environment.apiUrl}/Documents/SupplierUserConditionsDocument`).toPromise();
  }

//End File

}
